import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  rowspan: "2",
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "TT", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Mã VT", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Tên vật tư", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "ĐVT", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Xuất mới", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "2",
  class: "text-center"
}, "Theo dõi thu hồi", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, [
  /*#__PURE__*/_createTextVNode(" Ghi chú"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "thu-hoi-header-help" }, "(Kế toán ký đối chiếu hằng tháng)")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Thu T/lý"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Tái SD")
], -1)
const _hoisted_10 = { class: "thu-hoi-col-index-row" }
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "A", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "B", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "C", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "D", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "1", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "2", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "3", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "E", -1)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "thu-hoi-col-text" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = { class: "thu-hoi-col-text" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["colspan"]
const _hoisted_30 = ["colspan"]
const _hoisted_31 = { class: "text-end fw-bolder" }
const _hoisted_32 = { class: "text-end fw-bolder" }
const _hoisted_33 = { class: "text-end fw-bolder" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_35 = {
  key: 1,
  class: "text-center text-muted py-5"
}

import { computed, PropType } from "vue";
import { formatQuantity } from "@/core/helpers/number-format";
import type { B01bRow, B01Totals } from "@/types/thu-hoi-vtpt";
import { THU_HOI_COLUMN_WIDTHS } from "./thu-hoi-column-widths";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThuHoiB01bTable',
  props: {
  rows: {
    type: Array as PropType<B01bRow[]>,
    required: true,
  },
  totals: {
    type: Object as PropType<B01Totals>,
    required: true,
  },
  showEmpty: {
    type: Boolean,
    default: true,
  },
  selectable: {
    type: Boolean,
    default: false,
  },
  selectedIds: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
  isPrintModal: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:selectedIds"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const colW = THU_HOI_COLUMN_WIDTHS;

const canSelect = computed(() => props.selectable && !props.isPrintModal);

const tableClass = computed(() =>
  props.isPrintModal
    ? "thu-hoi-table bao-cao-table--print"
    : "table core-table thu-hoi-table"
);

const colSpan = computed(() => (canSelect.value ? 9 : 8));

const allSelected = computed(
  () =>
    props.rows.length > 0 &&
    props.rows.every((row) => props.selectedIds.includes(row.id_vat_tu))
);

const isIndeterminate = computed(
  () =>
    props.selectedIds.length > 0 && props.selectedIds.length < props.rows.length
);

const toggleSelectAll = (checked: boolean | string | number) => {
  if (checked) {
    emit(
      "update:selectedIds",
      props.rows.map((row) => row.id_vat_tu)
    );
    return;
  }

  emit("update:selectedIds", []);
};

const toggleRow = (id: number, checked: boolean | string | number) => {
  if (checked) {
    if (props.selectedIds.includes(id)) return;
    emit("update:selectedIds", [...props.selectedIds, id]);
    return;
  }

  emit(
    "update:selectedIds",
    props.selectedIds.filter((selectedId) => selectedId !== id)
  );
};

const onRowClick = (id: number) => {
  if (!canSelect.value) return;
  toggleRow(id, !props.selectedIds.includes(id));
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (__props.rows.length || __props.showEmpty)
    ? (_openBlock(), _createElementBlock("table", {
        key: 0,
        class: _normalizeClass(tableClass.value)
      }, [
        _createElementVNode("colgroup", null, [
          (canSelect.value)
            ? (_openBlock(), _createElementBlock("col", {
                key: 0,
                style: _normalizeStyle({ width: `${_unref(colW).select}px` })
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).stt}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).ma}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).ten}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).dvt}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).text}px` })
          }, null, 4)
        ]),
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (canSelect.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_1, [
                  _createVNode(_component_el_checkbox, {
                    "model-value": allSelected.value,
                    indeterminate: isIndeterminate.value,
                    onChange: toggleSelectAll
                  }, null, 8, ["model-value", "indeterminate"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8
          ]),
          _hoisted_9,
          _createElementVNode("tr", _hoisted_10, [
            (canSelect.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_11))
              : _createCommentVNode("", true),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.id_vat_tu,
              class: _normalizeClass({
          'thu-hoi-row--selectable': canSelect.value,
          'thu-hoi-row--selected':
            canSelect.value && __props.selectedIds.includes(row.id_vat_tu),
          'bao-cao-table-data-row': __props.isPrintModal,
          'bao-cao-table-data-row--last':
            __props.isPrintModal && index === __props.rows.length - 1,
        }),
              onClick: ($event: any) => (onRowClick(row.id_vat_tu))
            }, [
              (canSelect.value)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: "text-center",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_el_checkbox, {
                      "model-value": __props.selectedIds.includes(row.id_vat_tu),
                      onChange: (checked) => toggleRow(row.id_vat_tu, checked)
                    }, null, 8, ["model-value", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_21, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(row.ma_vat_tu), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(row.ten_vat_tu), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(row.don_vi_tinh), 1),
              _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(formatQuantity)(row.xuat_moi)), 1),
              _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatQuantity)(row.thu_thanh_ly)), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(formatQuantity)(row.tai_su_dung)), 1),
              _createElementVNode("td", _hoisted_27, _toDisplayString(row.ghi_chu), 1)
            ], 10, _hoisted_20))
          }), 128)),
          (!__props.rows.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                _createElementVNode("td", {
                  colspan: colSpan.value,
                  class: "text-center text-muted"
                }, " Không có dữ liệu ", 8, _hoisted_29)
              ]))
            : _createCommentVNode("", true),
          (__props.rows.length)
            ? (_openBlock(), _createElementBlock("tr", {
                key: 1,
                class: _normalizeClass({
          'thu-hoi-table-total-row': !__props.isPrintModal,
          'bao-cao-table-total-row': __props.isPrintModal,
        })
              }, [
                _createElementVNode("td", {
                  colspan: canSelect.value ? 5 : 4,
                  class: "text-center fw-bolder"
                }, " Tổng cộng ", 8, _hoisted_30),
                _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(formatQuantity)(__props.totals.xuat_moi)), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(_unref(formatQuantity)(__props.totals.thu_thanh_ly)), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(formatQuantity)(__props.totals.tai_su_dung)), 1),
                _hoisted_34
              ], 2))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_35, "Không có dữ liệu"))
}
}

})